import styled from "styled-components";

export const DeliveryContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${props => (!!props.hasData ? "$ffffff" : "#eae7f6")};
    
    -webkit-box-align: center;
    -webkit-box-pack: center;
    justify-self: center;
    align-self: center;
    width: 85%;
    //margin-left: -5%;

    /* Responsive */
    @media (max-width: 1024px) {
        padding: ${props => (!!props.hasData ? "15px" : "0")};
    }
    @media (max-width: 768px) {
        padding: ${props => (!!props.hasData ? "10px" : "0")};
    }
    @media (max-width: 480px) {
        padding: ${props => (!!props.hasData ? "5px" : "0")};
    }
    
`;


export const TextCard = styled.div`
    flex: 1;
    max-width: 100%;
    background-color: #ffffff;
    border-radius: 0.75rem;
    box-shadow: 0px 8px 31px rgba(0, 0, 0, 0.15);
    text-align: center;
 
    padding-bottom: ${props => (!!props.hasData ? "30px" : "0")};
    padding-left: ${props => (!!props.hasData ? "30px" : "0")};
    padding-right: ${props => (!!props.hasData ? "30px" : "0")};
    
    margin-top: ${props => (props.hasData ? "20px" : "0")};
    margin-bottom: ${props => (props.hasData ? "20px" : "0")};
  


`;

export const TextLines = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const TextLine = styled.div`
    color: #374151;
    line-height: 1.6;
    font-size: 1.25rem;
    margin: 0;
    font-weight: 700;
`;


